import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable, InjectionToken } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, retryWhen, tap } from 'rxjs/operators';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

@Injectable({providedIn: 'root'})
export class ApiService {

  constructor(
    private httpClient: HttpClient
  ) { }

  handleError(error: HttpErrorResponse) {
    let errorMessage = "Unknown error!";
    if (error.error instanceof ErrorEvent) {
      // Client side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server side errors
      // errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}\n\n-${error.error.error_msg}`;
      errorMessage = error.error.error_msg || `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(errorMessage);
  }

  private retryHandler(err) {
    let attempts = 0;
    return err.pipe(
      tap(error => {
        if (++attempts > 3 || !(error['status'] === 200 && error['status'] === 400)) {
          throw error;
        }
      })
    );
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    let attempts = 0;
    return this.httpClient.get(path, { params }).pipe(
      retryWhen(this.retryHandler),
      catchError(this.handleError)
    );
  }

  get1(path: string, options): Observable<any> {
    return this.httpClient.get(path, options).pipe(
      retryWhen(this.retryHandler),
      catchError(this.handleError)
    );
  }

  get2(path: string, options): Observable<any> {
    return this.httpClient.get(path, options).pipe(
      retryWhen(this.retryHandler),
    );
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.httpClient.put(path, JSON.stringify(body)).pipe(
      retryWhen(this.retryHandler),
      catchError(this.handleError)
    );
  }

  post(path: string, body: any | null, options?): Observable<any> {
    return this.httpClient.post(path, body, options).pipe(
      retryWhen(this.retryHandler),
      catchError(this.handleError)
    );
  }

  post1(path: string, body: any | null, options?): Observable<any> {
    return this.httpClient.post(path, body, options);
  }

  delete(path): Observable<any> {
    return this.httpClient.delete(path).pipe(
      retryWhen(this.retryHandler),
      catchError(this.handleError)
    );
  }
}
